import { downgradeComponent } from '@angular/upgrade/static';
import * as angular from 'angular';
import 'tinymce';
import 'angular-ui-tinymce';
import { NgxRichTextEditorComponent } from './rich-text-editor.component';

// TODO - remove when activityInstructionsEditor STAB-947
export { NgxRichTextEditorModule } from './rich-text-editor.module';
export const ngxRichTextEditorModule = angular.module('ngxRichTextEditorModule', [])
	.directive('ngxRichTextEditor', downgradeComponent({ component: NgxRichTextEditorComponent }))
	.value('uiTinymceConfig', {
		baseUrl: '@@PUBLIC_PATH@@'
	})
	.name;
